var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTelegram = function SvgTelegram(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33461 7.79076L14.3098 2.48633C15.5945 1.92881 19.9302 0.16067 19.9302 0.16067C19.9302 0.16067 21.9375 -0.619861 21.7609 1.25979C21.7127 2.04032 21.2631 4.73235 20.8134 7.66332L19.4164 16.3288C19.4164 16.3288 19.304 17.6031 18.3565 17.8262C17.4091 18.0492 15.8514 17.0456 15.5784 16.8385C15.3536 16.6793 11.4032 14.1943 9.95797 12.9677C9.57257 12.6332 9.12293 11.9801 10.0061 11.1996C12.0134 9.38368 14.4061 7.1058 15.8514 5.67217C16.5259 5.00315 17.1842 3.45802 14.4061 5.33766L6.55359 10.5784C6.55359 10.5784 5.65432 11.1359 3.98424 10.6262C2.31417 10.1164 0.387164 9.49518 0.387164 9.49518C0.387164 9.49518 -0.945683 8.66686 1.33461 7.79076Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTelegram, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/telegram.9ba5ae0b.svg";
export { ForwardRef as ReactComponent };